import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface StatusInfo {
    order_status: number;
    order_status_text: string;
    cancel_reason_idx?: number;
    cancel_reason?: string;
    branch_type: string;
    branch_name: string;
    branch_idx: number;
    branch_del?: "Y" | "N"; // 지점 삭제 여부
    branch_option: string;
    customer_branch_idx: number;
    customer_manager: {
        customer_manager_name: string;
        customer_manager_date: string;
    };
    payment_status_text: string;
    branch_payment_status_text: string;
    branch_req: string;
    branch_product_image: ProductImage[];
}

export interface MemberInfo {
    customer_idx: number;
    member_idx: number;
    customer_name: string;
    m_name: string;
    m_mobile: string;
    order_name: string;
    order_mobile: string;
    special: boolean;
}

export interface ProductImage {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface ManagerInfo {
    customer_manager_idx: number;
    manager_name: string;
    manager_mobile: string;
    alrimtalk_flag: boolean;
}

export interface ProductInfo {
    product_idx: number;
    product_image: ProductImage;
    product_category_idx: number;
    product_category: string;
    product_name: string;
    product_category_union_option: boolean;
    product_amount: number;
    sales_amount: number;
    order_amount: number;
    ready_image: ProductImage[];
    delivered_image: ProductImage[];
    delivery_name: string;
    delivery_amount: number;
    delivery_idx: number;
    product_code: string;
    product_code_name: string;
    product_quantity: number;
    customer_request: string;
}

export interface EventContent {
    event_content_idx: number;
    depth1_idx: number;
    depth1: string;
    depth2: string;
    event_content: string;
}

export interface RecipientInfo {
    wreath_sender: string;
    wreath_word: string;
    recipient_name: string;
    recipient_mobile: string;
    is_union: boolean;
    event_content: EventContent;
    related_person: string;
    work_location: string;
    department: string;
    company_tel: string;
    delivery_immediate: boolean;
    delivery_date: string;
    delivery_time: string;
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail: string;
    delivery_memo_idx: number;
    delivery_memo: string;
    order_file: ProductImage[];
    file_memo: string;
    order_memo: string;
}

export interface OrderData {
    admin_write: boolean;
    direct: boolean;
    order_idx: number;
    order_number: string;
    delivery_date: string;
    order_date: string;
    status_info: StatusInfo;
    customer_manager: ManagerInfo[];
    member_info: MemberInfo;
    product_info: ProductInfo;
    recipient_info: RecipientInfo;
}

export interface GetOrderResponse {
    statusCode: number;
    message: string;
    data: OrderData;
}

export const useGetOrderInfo = (orderId: number): UseQueryResult<OrderData, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<OrderData, Error>({
        queryKey: ["getOrderInfo", orderId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_info}/${orderId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return prevData;
            }
            return undefined;
        },
    });
};
